const EASING = 'cubic-bezier(0.22, 1, 0.36, 1) 300ms both'

export const MENU_IN_FROM_TOP = `menu-in-from-top ${EASING}`
export const MENU_IN_FROM_BOTTOM = `menu-in-from-bottom ${EASING}`

export const STEP_SLIDE_DURATION_MS = 600
const STEP_EASING = `cubic-bezier(0.22, 1, 0.36, 1) ${STEP_SLIDE_DURATION_MS}ms both`

export const STEP_SLIDE_IN_RIGHT = `step-slide-in-right ${STEP_EASING}`
export const STEP_SLIDE_IN_LEFT = `step-slide-in-left ${STEP_EASING}`
export const STEP_SLIDE_OUT_LEFT = `step-slide-out-left ${STEP_EASING}`
export const STEP_SLIDE_OUT_RIGHT = `step-slide-out-right ${STEP_EASING}`
